import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import React, { useEffect } from 'react';
import ReduxFormCheckbox from 'shared/components/ReduxFormCheckbox';
import { BrowserView, MobileView } from 'react-device-detect';
import removeHTML from 'shared/utils/removeHTML';
import { APP_TYPE_CUSTOMER_JOINT } from 'features/ApplicationEntry/constants';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import {
	Typography,
	Toolbar,
	Paper,
	Step,
	StepButton,
	StepLabel,
	Stepper,
	Modal,
	Button,
	Accordion as ExpansionPanel,
	AccordionSummary as ExpansionPanelSummary,
	AccordionDetails as ExpansionPanelDetails,
} from '@material-ui/core';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import theme from 'shared/themes/storis';
import { PROVIDER_TD_BANK } from '../Shared/constants';
import withRouter from 'shared/utils/WithRouter';
import '@react-pdf-viewer/core/lib/styles/index.css';

export const styles = {
	checkBoxText: {
		fontSize: '12px',
	},
	form: {
		marginBottom: '24px',
	},
	message: {
		paddingBottom: '15px',
		opacity: '0.7',
	},
	modal: {
		position: 'fixed',
		width: '100%',
		maxWidth: '400px',
		height: '100%',
		maxHeight: '250px',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		padding: '20px',
		'@media only screen and (max-width: 420px) and (orientation: portrait)': {
			maxWidth: '275px',
		},
	},
	modalButtons: {
		position: 'absolute',
		bottom: '20px',
		right: '20px',
		marginTop: '20px',
	},
	panel: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		marginTop: '20px !important',
		marginLeft: 'auto !important',
		marginRight: 'auto !important',
	},
	pdfPanel: {
		width: '95%',
		maxWidth: '800px',
		height: '750px',
		marginTop: '20px !important',
		marginLeft: 'auto !important',
		marginRight: 'auto !important',
		overflowY: 'scroll !important',
	},	
	stepper: {
		backgroundColor: '#FFFFFF',
		width: '95%',
		height: 'auto',
		maxWidth: '800px',
		marginTop: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	bottomButtons: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexShrink: '0',
		paddingLeft: 0,
	},
	buttonToolbar: {
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
	},
	mobileStepIndicator: {
		marginLeft: '16px',
		marginTop: '18px',
		color: theme.palette.primary.main,
	},
	headerLogo: {
		height: '100%',
		textAlign: 'center',
		margin: 'auto'
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',
		width: '100%',
	},	
	eStatementText: {
		textAlign: 'left',
		display: 'inline-flex',
		alignItems: 'baseline',
		paddingBottom: '15px',
	},
};

function TermsAndConditions(props) {
	const {
		classes,
		handleSubmit,
		modalMessage,
		modalOpen,
		modalTitle,
		openCancelConfirmModal,
		settings,
		valid,
		applicantIndicator,
		closeModal,
		destroyAllStatuses,
		providerId,
	} = props;

	const handleClose = () => {
		closeModal();
		props.router.navigate('/now');
		window.location.reload(true);
	};

	useEffect(() => {
		if (settings === undefined) {
			props.router.navigate('/now');
		}
		window.scrollTo(0, 0);
		destroyAllStatuses();
	}, []);

	return settings != null ? (
		<form onSubmit={handleSubmit} className={classes.form}>
			<div className={classes.buttonToolbar}>
				<Toolbar className={classes.topButtons}>
					<div className={classes.headerLogo}>
						<img alt="logo" id="header-logo-image" className={classes.logoImg} />
					</div>
				</Toolbar>
			</div>
			<div className={classes.stepperToolbar}>
				<MobileView>
					<Typography
						type="body1"
						component="div"
						className={classes.mobileStepIndicator}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: removeHTML('Step 3 of 4'),
						}}
					/>
				</MobileView>
				<BrowserView>
					<Stepper className={classes.stepper} activeStep={2} alternativeLabel>
						<Step key={1}>
							<StepButton
								icon={<EditIcon color="primary" />}
								onClick={() =>
									props.router.navigate({
										pathname: '/ApplicationEntry',
										state: {
											update: true,
										},
									})
								}
							>
								<StepLabel>Personal Information</StepLabel>
							</StepButton>
						</Step>
						<Step key={2}>
							<StepLabel>Review</StepLabel>
						</Step>
						<Step key={3}>
							<StepLabel>Agreement</StepLabel>
						</Step>
						<Step key={4}>
							<StepLabel>Status</StepLabel>
						</Step>
					</Stepper>
				</BrowserView>
			</div>
			<ExpansionPanel defaultExpanded elevation={4} className={classes.panel}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography type="headline">
						{settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsTitle}
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ flexDirection: 'column' }}>
					<Typography type="subheading" component="div" className={classes.message}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsText,
							}}
						/>
					</Typography>
				</ExpansionPanelDetails>
			</ExpansionPanel>
			{settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsPdf !== ''
				? settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsPdf.map((pdfDoc, index) => (
					<ExpansionPanel key={index} className={classes.pdfPanel} defaultExpanded elevation={4}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} />
						<ExpansionPanelDetails
							style={{
								flexDirection: 'column',
								WebkitOverflowScrolling: 'touch',
							}}
						>
							<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
								<Viewer fileUrl={pdfDoc.PDFName} />
							</Worker>
						</ExpansionPanelDetails>
					</ExpansionPanel>
					))
					: null}					
			{/* eslint-enable prettier/prettier */}
			<ExpansionPanel className={classes.panel} defaultExpanded elevation={4}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography type="headline">{settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.ConfirmationTitle}</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ flexDirection: 'column' }}>
					<Typography type="subheading" component="div" className={classes.message}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.ConfirmationText),
							}}
						/>
					</Typography>
					{providerId && providerId === PROVIDER_TD_BANK ? (
						<div>
							<Typography type="subheading" component="div">
								<div
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsPaperlessStatementsSectionHeaderText),
									}}
								/>
							</Typography>
							<Field
								name="eStatementAccept"
								component={ReduxFormCheckbox}
								label={
									<Typography type="subheading" component="span" className={classes.eStatementText}>
										<span
											// eslint-disable-next-line react/no-danger
											dangerouslySetInnerHTML={{
												__html: settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsPaperlessStatementsAcceptText
											}}
										/>
									</Typography>
								}
								biggerCheckbox
								style={{ paddingLeft: '5px' }}
							/>
							<Field
								name="eStatementDecline"
								component={ReduxFormCheckbox}
								label={
									<Typography type="subheading" component="span" className={classes.eStatementText}>
										<span
											// eslint-disable-next-line react/no-danger
											dangerouslySetInnerHTML={{
												__html: settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsPaperlessStatementsDeclineText
											}}
										/>
									</Typography>
								}
								biggerCheckbox
								style={{ paddingLeft: '5px' }}
							/>							
						</div>
					) : null}
					<Typography className={classes.checkBoxText}>
						{settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.ApplicantLabel}
					</Typography>
					<Field
						name="applicantAgrees"
						component={ReduxFormCheckbox}
						biggerCheckbox
						label={settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.ApplicantDescription}
						style={{ paddingLeft: '5px' }}
					/>
					{providerId && providerId === PROVIDER_TD_BANK ? (
						<Field
							name="applicantAcknowledges"
							component={ReduxFormCheckbox}
							label={
								<Typography type="subheading" component="span" className={classes.message}>
									<span
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: removeHTML(
												settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsAcknowledgementText,
											),
										}}
									/>
								</Typography>
							}
							biggerCheckbox
							style={{ paddingLeft: '5px' }}
						/>
					) : null}
					{applicantIndicator === APP_TYPE_CUSTOMER_JOINT ? (
						<div>
							<Typography className={classes.checkBoxText}>
								{settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.CoApplicantLabel}
							</Typography>
							<Field
								name="coApplicantAgrees"
								component={ReduxFormCheckbox}
								biggerCheckbox
								label={settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.CoApplicantDescription}
								style={{ paddingLeft: '5px' }}
							/>
							{providerId && providerId === PROVIDER_TD_BANK ? (
								<Field
									name="coApplicantAcknowledges"
									component={ReduxFormCheckbox}
									label={
										<Typography type="subheading" component="span" className={classes.message}>
											<span
												// eslint-disable-next-line react/no-danger
												dangerouslySetInnerHTML={{
													__html: removeHTML(
														settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsAcknowledgementText,
													),
												}}
											/>
										</Typography>
									}
									biggerCheckbox
									style={{ paddingLeft: '5px' }}
								/>
							) : null}
						</div>
					) : null}
					<Typography type="subheading" component="div" className={classes.message}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.TermsAndConditionsDisclosureText,
							}}
						/>
					</Typography>
					<Typography type="subheading" component="div">
						<Toolbar className={classes.bottomButtons}>
							<Button variant="contained" color="primary" type="submit" disabled={!valid}>
								Submit
							</Button>
							<Button onClick={openCancelConfirmModal}>Cancel</Button>
						</Toolbar>
						<div
							className={classes.message}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.TermsAndConditionsPageSettings.ConfirmationFooter),
							}}
						/>
					</Typography>
				</ExpansionPanelDetails>
			</ExpansionPanel>
			<Modal open={modalOpen}>
				<Paper className={classes.modal}>
					<Typography type="headline" gutterBottom>
						{modalTitle}
					</Typography>
					<Typography type="subheading">{modalMessage}</Typography>
					<Button className={classes.modalButtons} variant="contained" color="primary" onClick={handleClose}>
						Okay
					</Button>
				</Paper>
			</Modal>
		</form>
	) : null;
}

TermsAndConditions.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	closeModal: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	modalMessage: PropTypes.string.isRequired,
	modalOpen: PropTypes.bool.isRequired,
	modalTitle: PropTypes.string,
	openCancelConfirmModal: PropTypes.func.isRequired,
	applicantIndicator: PropTypes.string.isRequired,
	destroyAllStatuses: PropTypes.func.isRequired,
	providerId: PropTypes.string,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
		fieldAndFooterSettings: PropTypes.shape({}),
	}),
	valid: PropTypes.bool.isRequired,
};

TermsAndConditions.defaultProps = {
	modalTitle: '',
	settings: undefined,
	providerId: '',
};

export default withRouter(withStyles(styles, { name: 'TermsAndConditions' })(TermsAndConditions));
